import type { PatientRegistration, User } from "~/shared.types";

export type PatientIdRow = Omit<PatientRegistration, "providerGroup"> & {
  providerGroup: PatientRegistration["providerGroup"] | null;
};

export const formatPatientId = (patientId: string, isPrimary: boolean) =>
  `${isPrimary ? "E" : ""}#${patientId}`;

export const getPatientIdRows = (user: User): PatientIdRow[] => {
  const registrations = user.patientRegistrations ?? [];
  const { ehrId } = user;

  if (
    !ehrId ||
    registrations.some((registration) => registration.patientId === ehrId)
  ) {
    return registrations;
  }

  return [
    ...registrations,
    { patientId: ehrId, isPrimary: false, providerGroup: null, states: [] },
  ];
};

export const getBannerPatientId = (user: User) => {
  const primary = user.patientRegistrations?.find(
    (registration) => registration.isPrimary && registration.patientId,
  );

  if (primary?.patientId) {
    return { patientId: primary.patientId, isPrimary: true };
  }

  return user.ehrId ? { patientId: user.ehrId, isPrimary: false } : null;
};
